import React, {useState, useContext} from 'react';
import {Button} from '@material-ui/core';
import {ThemeContext} from './../../../themes/ThemeProvider';
import WorkQueueSearchTable from './WQAccountSearchTable ';
import {ArrowBack} from '@material-ui/icons';
import {backButtonText} from '../../../util/Content';

const WorkQueueSearch = ({setTabValue, workQueueRowData}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);


  return (
    <div className="new-standard-textfields">
      <Button
        variant="outlined"
        type="button"
        className={`search-btn mx-1 ${classes.buttonRoot}`}
        onClick={() => {
          setTabValue(0);
        }}
      >
        <ArrowBack className="mr-2" />
        {backButtonText}
      </Button>
      <WorkQueueSearchTable
        setTabValue={setTabValue}
        searchData={searchData}
        setSubmit={setSubmit}
        submit={submit}
        setSearchData={setSearchData}
        workQueueRowData={workQueueRowData}
      />
    </div>
  );
};

export default WorkQueueSearch;
